import React, { Component } from 'react';
import { Col, Image } from 'react-bootstrap';
import AIOICompanyLogo from "src/img/AIS Asia Logo Vertical.png";

class Logo extends Component {

    render() {
        return (
          <Col>
              <p className="poweredBy">Powered By:</p>
              <Image className="AIOICompanyLogo" src={AIOICompanyLogo} responsive />
          </Col>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/js/AIOILogo.js